import { IkasProductBrandTranslation } from "./translation";
import { initIkasHTMLMetaData } from "../html-meta-data/init";
import { IkasBrand } from ".";

export function initIkasBrand(brand: IkasBrand, locale: string | null) {
  brand.image = brand.imageId ? { id: brand.imageId, isVideo: false } : null;
  brand.metaData && initIkasHTMLMetaData(brand.metaData, locale);

  if (brand.translations && locale) {
    setTranslations(brand, brand.translations, locale);
    delete brand.translations;
  }
}

function setTranslations(
  brand: IkasBrand,
  translations: IkasProductBrandTranslation[],
  locale: string
) {
  if (translations && translations.some((t) => t.locale === locale)) {
    const localeTranslations = translations.find((t) => t.locale === locale);

    if (localeTranslations?.name) brand.name = localeTranslations.name;
    if (localeTranslations?.description)
      brand.description = localeTranslations.description;
  }
}
